import axios from "axios";

const state = {};

const getters = {};

const actions = {
  getReviews({ commit }, payload) {
    commit("SET_SNACKBAR", {
      visibility: false,
      color: "error",
      text: null
    });
    return axios
      .get(
        process.env.VUE_APP_API_URL +
          "/review/get_by.php?subkriteria=" +
          payload
      )
      .then(res => {
        return res.data;
      })
      .catch(() => {
        return [];
      });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
